'use client';

import { HeaderAnchor } from './header-link';
import { MARK_PATH, WORDMARK_PATH } from './logo-mark';
import type { HeaderLinkAction, HeaderPlacement } from './model';

export function HeaderLogo({
  action,
  placement,
  onClick,
}: {
  action: HeaderLinkAction;
  placement: Extract<HeaderPlacement, 'bar' | 'drawer'>;
  onClick?: () => void;
}) {
  const wordmarkOnly = placement === 'drawer';
  return (
    <HeaderAnchor
      action={action}
      placement={placement}
      onClick={onClick}
      aria-label="Opendoor home"
      className={
        wordmarkOnly
          ? 'inline-flex items-center text-od-content-primary'
          : // The 40px box keeps the mobile mark a usable touch target; the mark stays on the
            // header's content edge.
            'inline-flex size-10 items-center justify-start text-current site-header-desktop:size-auto'
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={26}
        viewBox="0 0 14 20"
        fill="none"
        aria-hidden
        className={wordmarkOnly ? 'hidden' : 'block site-header-desktop:hidden'}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={MARK_PATH} fill="currentColor" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={96}
        height={21}
        viewBox="0 0 256 56"
        fill="none"
        aria-hidden
        className={wordmarkOnly ? 'block' : 'hidden site-header-desktop:block'}
      >
        <path d={WORDMARK_PATH} fill="currentColor" />
      </svg>
    </HeaderAnchor>
  );
}
